import styled from 'styled-components'
// @ts-ignore
import { basicColor } from '@netbasequid/theme'
import StyledTinyMCE from './tinyMCE.css'

const StyledRichTextContent = styled(StyledTinyMCE)`
  font-size: 14px;
  * {
    color: ${({ displayTheme }) =>
      displayTheme === 'dark' ? basicColor.GRAY_100 : basicColor.GRAY_1400};
  }

  a {
    color: ${({ displayTheme }) =>
      displayTheme === 'dark' ? basicColor.BLUE_400 : basicColor.BLUE_800};
  }

  table:not([border='0']):not([style*='border-width']) th,
  table:not([border='0']):not([style*='border-width']) td {
    border-width: 1px;
  }

  table:not([border='0']):not([style*='border-style']) th,
  table:not([border='0']):not([style*='border-style']) td {
    border-style: solid;
  }

  table:not([border='0']):not([style*='border-color']) th,
  table:not([border='0']):not([style*='border-color']) td {
    border-color: ${({ displayTheme }) => (displayTheme === 'dark' ? '#6d737b' : '#ccc')};
  }

  :not([dir='rtl']) blockquote {
    border-left: 2px solid ${({ displayTheme }) => (displayTheme === 'dark' ? '#6d737b' : '#ccc')};
    margin-left: 1.5rem;
    padding-left: 1rem;
  }

  [dir='rtl'] blockquote {
    border-right: 2px solid ${({ displayTheme }) => (displayTheme === 'dark' ? '#6d737b' : '#ccc')};
    margin-right: 1.5rem;
    padding-right: 1rem;
  }

  pre {
    background-color: ${({ displayTheme }) =>
      displayTheme === 'dark' ? basicColor.GRAY_1300 : basicColor.GRAY_200};
    padding: 9px 12px;
    border-radius: 4px;
    border: 1px solid
      ${({ displayTheme }) =>
        displayTheme === 'dark' ? basicColor.GRAY_1100 : basicColor.GRAY_400};
    white-space: pre-wrap;
    word-wrap: break-word;
    margin: 0;
  }

  ul {
    padding: 0;
    margin: 0 0 10px 25px;
  }

  ul ul,
  ul ol,
  ol ol,
  ol ul {
    margin-bottom: 0;
  }

  li {
    line-height: 20px;
  }

  h1 {
    margin: 0.37em 0;
  }

  h2 {
    margin: 0.53em 0;
  }

  h3 {
    margin: 0.83em 0;
  }

  h4 {
    margin: 1.13em 0;
  }

  h5 {
    margin: 1.37em 0;
  }

  h6 {
    margin: 1.63em 0;
  }
`

export default StyledRichTextContent
